// extracted by mini-css-extract-plugin
export default {"tagsContainer":"tags-module--tags-container--7919L"};